import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './certificadoEmissaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { 
	setModoTela, initForm, salvar, excluir, getLista, getListaChecklistResposta, getListaModelo, importar, getQRCode,
	getListaCliente, getListaGrupo
 } from './certificadoEmissaoActions';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import DateFormat from '../common/dateFormat/DateFormat';

class CertificadoEmissao extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(10)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		ids_origem: [],
		ids_grupo: [],
		ids_cliente: []
	}

	componentDidMount() {

		const fileSelector = document.createElement('input');
		fileSelector.setAttribute('type', 'file');
		fileSelector.addEventListener("change", async (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
					|| (file.type.includes('application/excel') || file.type.includes('application/vnd.ms-excel'))) {
					setError('Selecione apenas (.XLSX)');
					return;
				}

				let tabela = [];
				await readXlsxFile(file, { sheet: 1 }).then((rows) => {
					tabela = rows;
				});

				this.props.importar(tabela);

				reader.readAsDataURL(file);

			}
		});

		this.fileSelector = fileSelector;

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaChecklistResposta();
		this.props.getListaModelo();
		this.props.getListaCliente();
		this.props.getListaGrupo();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`
					${DateFormat.formatarDataSqlParaTela(item.data_emissao || item.datahora_inclusao)}
					${item.nome_aluno || ''}
					${item.nome_instrutor || ''}
					${item.nome_cliente || ''}
					${item.nome_cidade || ''}
					${item.nome_estado || ''}
					${item.curso || item.nome_checklist || ''}
					${item.email || ''}
					${item.token || ''}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}

			if (this.state.data_inicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_emissao || item.datahora_inclusao)) < DateFormat.formatarDataTelaParaSql(this.state.data_inicial)) {
				return false;
			}
			if (this.state.data_final
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_emissao || item.datahora_inclusao)) > DateFormat.formatarDataTelaParaSql(this.state.data_final)) {
				return false;
			}
			if ((this.state.ids_origem || []).length && !(this.state.ids_origem || []).includes(item.id_origem)) {
				return false;
			}
			if ((this.state.ids_grupo || []).length && !(this.state.ids_grupo || []).includes(item.id_grupo)) {
				return false;
			}
			if ((this.state.ids_cliente || []).length && !(this.state.ids_cliente || []).includes(item.id_cliente)) {
				return false;
			}

			return true;
		});

		let paginacao = [];

		if (this.props.lista.length) {
			for (let i = 0; i < this.props.lista.length; i += 1500) {				
				paginacao.push({
					inicio: i,
					fim: i + 1499
				});				
			}
		} else {
			paginacao.push({
				inicio: 0,
				fim: 1499
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2' minWidth={220}>
							<Button
								text='Adicionar do Checklist'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_origem: 1 });
								}} />
						</Grid>
						<Grid cols='6 6 4 2' minWidth={220}>
							<Button
								text='Importar do KeplerFlix'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_origem: 2 });
								}} />
						</Grid>
						<Grid cols='6 6 4 2' minWidth={220}>
							<Button
								text='Adicionar Checklist Avulso'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ id_origem: 3 });
								}} />
						</Grid>
					</Row>
					<br />
					<Row>

						<LabelAndInputMask
							label='Data Inicial'
							cols='12 12 6 2'
							placeholder='Informe'
							mask={'99/99/9999'}
							value={this.state.data_inicial}
							onChange={data => {
								this.setState({
									...this.state,
									data_inicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							label='Data Final'
							cols='12 12 6 2'
							placeholder='Informe'
							mask={'99/99/9999'}
							value={this.state.data_final}
							onChange={data => {
								this.setState({
									...this.state,
									data_final: data.target.value
								});
							}} />

						<Select
							options={[{ id: 1, valor: 'Checklist' }, { id: 2, valor: 'KeplerFlix' }, { id: 3, valor: 'Checklist Avulso' }]}
							label='Tipo'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_origem}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_origem: values.map(item => item.value)
								});
							}} />

						<Select
							options={this.props.listaGrupo}
							label='Região / Grupo'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_grupo}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_grupo: values.map(item => item.value)
								});
							}} />

						<Select
							options={this.props.listaCliente.filter(item => !(this.state.ids_grupo || []).length || (this.state.ids_grupo || []).includes(item.id_grupo))}
							label='Cliente'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_cliente}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_cliente: values.map(item => item.value)
								});
							}} />
					
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<ul class='pagination pagination-sm m-0 float-right'>
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: this.state.paginacaoIndice > 0 ? this.state.paginacaoIndice - 1 : this.state.paginacaoIndice
								})}>{'<<'}
							</a>
						</li>
						
						{paginacao.map((item, i) => (
							<li class='page-item'>
								<a class='page-link'  
									style={{ 
										fontWeight: 'bold',
										cursor: 'pointer',
										backgroundColor: i == this.state.paginacaoIndice ? '#f57215' : null,
										color: i == this.state.paginacaoIndice ? '#fff' : null
									}}
									onClick={() => this.setState({
										...this.state,
										paginacaoIndice: i
									})}>{i + 1}
								</a>
							</li>
						))}
						
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: paginacao.length - 1 > this.state.paginacaoIndice ? this.state.paginacaoIndice + 1 : this.state.paginacaoIndice
								})}>{'>>'}
							</a>
						</li>
					</ul>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter>Emissão</Th>
								<Th alignCenter>Aluno</Th>
								<Th alignCenter>Instrutor</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Cidade</Th>
								<Th alignCenter>Estado</Th>
								<Th alignCenter>Treinamento/Curso</Th>
								<Th alignCenter>Token</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.filter((item, i) => {
								return i >= paginacao[this.state.paginacaoIndice].inicio && i <= paginacao[this.state.paginacaoIndice].fim;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td small alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_emissao || item.datahora_inclusao)}</Td>
									<Td small alignCenter>{item.nome_aluno}</Td>
									<Td small alignCenter>{item.nome_instrutor}</Td>
									<Td small alignCenter>{item.nome_cliente}</Td>
									<Td small alignCenter>{item.nome_cidade}</Td>
									<Td small alignCenter>{item.nome_estado}</Td>
									<Td small alignCenter>{item.curso || item.nome_checklist}</Td>
									<Td small alignCenter>{item.token}</Td>
									<Td small alignRight minWidth={10}>																			
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.initForm({
													...item
												});
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.getQRCode(item.token);
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.certificadoEmissao.modoTela,
	aguardando: state.certificadoEmissao.aguardando,
	lista: state.certificadoEmissao.lista,
	listaCliente: state.certificadoEmissao.listaCliente,
	listaGrupo: state.certificadoEmissao.listaGrupo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaChecklistResposta, getListaModelo, importar, getQRCode,
	getListaCliente, getListaGrupo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CertificadoEmissao);